export default __webpack_public_path__ + "static/media/element_67.814f8518.avif";